import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getAmazonQInstructions = (playground, bearerToken, mcpServerUrl) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let codeSnippet = `{
    "mcpServers": {
      "${sanitizeName(playground.name)}": {     
        "command": "npx",
        "args": ["mcp-remote", "${mcpServerUrl}"]
      }
    }
  }`;

  if (playground.authType === "BEARER_TOKEN") {
    codeSnippet = `{
    "mcpServers": {
      "${sanitizeName(playground.name)}": {
        "command": "npx",
        "args": ["mcp-remote", "${mcpServerUrl}", "--header", "Authorization:Bearer ${
      bearerToken ? bearerToken : "<YOUR_API_KEY>"
    }"]    
      }
    }
  }`;
  }
  const result = `
${oauthNote}Add the configuration below to the mcp.json config file in your home directory in ~/.aws/amazonq/mcp.json if you want it to be applied to all projects on your computer.

Alternatively, you can store the configuration in the workspace root at .aws/amazonq/mcp.json so it is shared among project members.

\`\`\`json
${codeSnippet}
\`\`\`

⚠️ Note: At the moment of writing, Amazon Q does not support the HTTP stream transport.

For further details, see [the official documentation here](https://docs.aws.amazon.com/amazonq/latest/qdeveloper-ug/qdev-mcp.html).
`;

  return result;
};

export default getAmazonQInstructions;
